import React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  SurveyFilterInformation,
  type SurveyFilterInformationProps,
} from '~/components/features/SurveyFilterInformation'
import { exists } from '~/utils'

import { useSampleSize } from '../hooks/useSampleSize'
import { type InputValues } from '../utils'

export const SurveyFilterInput = () => {
  const { setValue, watch } = useFormContext<InputValues>()
  const [filterGroups, surveyId] = watch([
    'surveyFilter.filterGroups',
    'surveyId',
  ])

  const sampleSize = useSampleSize()
  const handleChange = React.useCallback<
    EH<SurveyFilterInformationProps, 'onChange'>
  >(
    (surveyFilter) => {
      setValue('surveyFilter.count', surveyFilter?.count)
      setValue('surveyFilter.filterGroups', surveyFilter?.filterGroups ?? [])
    },
    [setValue],
  )

  if (!exists(surveyId)) {
    return null
  }

  return (
    <SurveyFilterInformation
      filterGroups={filterGroups}
      sampleSize={sampleSize}
      surveyId={surveyId}
      onChange={handleChange}
    />
  )
}
